import { render, staticRenderFns } from "./SelectPurchaseRequisition.vue?vue&type=template&id=22d356ca&"
import script from "./SelectPurchaseRequisition.vue?vue&type=script&lang=ts&"
export * from "./SelectPurchaseRequisition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22d356ca')) {
      api.createRecord('22d356ca', component.options)
    } else {
      api.reload('22d356ca', component.options)
    }
    module.hot.accept("./SelectPurchaseRequisition.vue?vue&type=template&id=22d356ca&", function () {
      api.rerender('22d356ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/SelectPurchaseRequisition.vue"
export default component.exports